import { showWebAppConfirm } from '@/utils/webAppConfirm';

export async function confirmRemoveCartItem(label?: string): Promise<boolean> {
  const message = label
    ? `Remove "${label}" from your cart?`
    : 'Remove this item from your cart?';

  return showWebAppConfirm({
    title: 'Remove item',
    message,
    confirmText: 'Remove',
    cancelText: 'Keep',
    variant: 'destructive',
  });
}

export async function confirmClearCart(): Promise<boolean> {
  return showWebAppConfirm({
    title: 'Clear Cart',
    message: 'Are you sure you want to remove all items from your cart?',
    confirmText: 'Clear Cart',
    cancelText: 'Keep Items',
    variant: 'destructive',
  });
}

export async function confirmClearCreatorGroup(creatorTitle: string): Promise<boolean> {
  return showWebAppConfirm({
    title: 'Clear items',
    message: `Remove all items from ${creatorTitle}?`,
    confirmText: 'Clear',
    cancelText: 'Keep Items',
    variant: 'destructive',
  });
}
